import { jsx as _jsx } from "react/jsx-runtime";
import { memo, useContext, useEffect, useMemo } from 'react';
import { hasValue, useT } from '@progress-fe/core';
import { Box } from '@chakra-ui/react';
import { JsFieldError, JsFieldInspector } from '../../jsFormBase';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
import { DialogableContainer } from '../../containers';
import { CutterDirectComponentTable } from './components';
/**
 * Component renders "/schemas/jsf-cutter-direct-component-map" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TFormData.
 */
const CutterDirectComponentMapJsFieldFC = (props) => {
    const { components, isInspector } = useContext(JsFormConfigContext) || {};
    const { dictionary = {} } = components || {};
    const { t } = useT();
    const formData = useMemo(() => (hasValue(props.formData) ? props.formData : null), [props.formData]);
    const { fieldConfig, fieldValues, onChangeFieldValues, onChangeFieldConfig } = useJsFieldFormData({
        config: formData?.fieldConfig ?? null,
        values: formData?.fieldValues ?? null,
        onChange: props.onChange
    });
    useEffect(() => {
        onChangeFieldConfig(formData?.fieldConfig);
    }, [formData?.fieldConfig, onChangeFieldConfig]);
    const handleChangeValue = (rootKey, key, value) => {
        if (!fieldValues) {
            return;
        }
        const fieldValuesCopy = structuredClone(fieldValues);
        fieldValuesCopy[rootKey][key] = value;
        if (hasValue(fieldValuesCopy[key]?.[rootKey])) {
            fieldValuesCopy[key][rootKey] = value;
        }
        onChangeFieldValues(fieldValuesCopy);
    };
    if (!fieldConfig || !fieldValues) {
        return _jsx(JsFieldError, { propName: props.name });
    }
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { pb: '2px', children: _jsx(DialogableContainer, { "data-testid": "CutterDirectComponentMapJsField-test", "data-name": props.name, title: t('CutterDirectComponentMap.name'), children: _jsx(CutterDirectComponentTable, { components: dictionary, fieldValues: fieldValues, isReadOnly: props.schema.readOnly, onChangeValue: handleChangeValue }) }) }) }));
};
export const CutterDirectComponentMapJsField = memo(CutterDirectComponentMapJsFieldFC);
//# sourceMappingURL=CutterDirectComponentMapJsField.js.map